import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { confetti } from '@shared/utils/helpers';

import ModalToBody from '../../../base/ModalToBody';
import { ajaxErrorHandler, defaultError, defaultSuccess } from '../../../libs/utils';
import { PREFERENCES_ACTIONS } from '../../../redux/preferences/actions';
import { selectEvent, selectWeekend } from '../../../redux/preferences/selectors';
import { getParkingVoucherByBarcode, redeemParkingVoucher } from '../../../services/api/parkingVouchers';
import ParkingStickersVouchersScanForm from './ParkingStickersVouchersScanForm';
import ParkingStickersVouchersStickerForm from './ParkingStickersVouchersStickerForm';

class _ParkingStickersVouchersScan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleSubmit = this._handleSubmit.bind(this);
    this._redeemSticker = this._redeemSticker.bind(this);
    this._closeModal = this._closeModal.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    printerSettings: PropTypes.object,
  };

  _closeModal() {
    this.setState({ voucher: undefined });
    document.body.classList.remove('modal-open');
  }

  _handleSubmit(values) {
    return new Promise((resolve, reject) => {
      getParkingVoucherByBarcode(this.props.event.id, values.barcode).then((response) => {
        if (!response.redeemedAt) {
          document.body.classList.add('modal-open');
          this.setState({
            sticker: response.parkingSticker,
            voucher: response,
          });
        } else {
          defaultError('Voucher already redeemed on: ' + response.redeemedAt);
        }

        resolve(response);
      });
    });
  }

  _redeemSticker(values) {
    const { voucher } = this.state;

    redeemParkingVoucher(voucher.crewMember.registrationId, voucher.id, values)
      .then((response) => {
        this.setState({
          sticker: undefined,
          voucher: undefined,
        });
        defaultSuccess('Sticker handed out');
        confetti(true);
        document.querySelector('input[name=barcode]').focus();
      })
      .catch((e) => {
        this.setState({ voucher: undefined });
        document.body.classList.remove('modal-open');
        ajaxErrorHandler(e);
      });
  }

  render() {
    const { voucher } = this.state;
    const showModal = voucher;

    return (
      <div>
        <ParkingStickersVouchersScanForm onSubmit={this._handleSubmit} />

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1039',
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    What Sticker?
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>

                {showModal && <ParkingStickersVouchersStickerForm voucher={voucher} onSubmit={this._redeemSticker} />}
              </div>
            </div>
          </div>

          <div
            className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1038',
            }}
          />
        </ModalToBody>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = function (state) {
  return {
    event: selectEvent(state),
  };
};

const BoxOfficeAccessVoucher = connect(mapStateToProps, mapDispatchToProps)(_ParkingStickersVouchersScan);

export default BoxOfficeAccessVoucher;
